import Axios from "axios";
import {
  SET_ABSENT_REPORT,
  UNSET_ABSENT_REPORT,
} from "@/store/mutation-types";
import {
  getAbsentReport,
} from "@/store/api";

const state = {
  absentReport: [],
};

const getters = {
  getAbsentReport(state) {
    return state.absentReport;
  },
};

const mutations = {
  [SET_ABSENT_REPORT](state, data) {
    state.absentReport = data;
  },
  [UNSET_ABSENT_REPORT](state) {
    state.absentReport = [];
  },
};

const actions = {
  getAbsentReport({ commit }, data) {
    return new Promise((resolve, reject) => {
      Axios.get(`${getAbsentReport}`, { params: data })
        .then((response) => {
          commit(SET_ABSENT_REPORT, response.data.data || []);
          resolve(response.data);
        })
        .catch((error) => {
          commit(UNSET_ABSENT_REPORT);
          reject(error);
        })
        .finally(() => {
          commit("UNSET_LOADING", null, { root: true });
        });
    });
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};

